<template>
    <div class="flex space-x-2 items-center justify-center" v-if="!column.isLocked">
        <edit-button
            v-if="!column.isEditing && column.entity.id"
            :label="$t('form.edit')"
            :tabindex="tabindex"
            color="orange" size="xxs"
            @click.native="column.isEditing = true"
        />

        <create-button
            v-if="!column.isEditing && !column.entity.id"
            :label="$t('form.create')"
            :tabindex="tabindex"
            color="green" size="xxs"
            @click.native="column.isEditing = true"
        />

        <template v-if="column.entity.id && !column.isEditing && column.isDeletable">
            <delete-button
                :loading="column.isLoading"
                :modal-content="deleteModalContent"
                :modal-title="deleteModalTitle"
                :tabindex="tabindex"
                size="xxs"
                @delete="actions.destroy(column)"
            />
        </template>

        <template v-if="column.isEditing">
            <default-button
                :label="$t('form.submit')"
                :loading="column.isLoading"
                :tabindex="tabindex"
                color="green"
                icon="check"
                size="xxs"
                @click.native="actions.upsert(column)"
            />
            <default-button
                :label="$t('form.cancel')"
                :loading="column.isLoading"
                :tabindex="tabindex"
                color="orange"
                icon="x-circle"
                size="xxs"
                @click.native="actions.reset(column)"
            />
        </template>

        <slot></slot>
    </div>
</template>

<script>
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';
import DataColumnActions from '@/Components/Storemanager/Entities/DataColumnActions';

export default {
    props: {
        column: {
            type: DataColumn,
            required: true,
        },

        actions: {
            type: DataColumnActions,
            required: true,
        },

        deleteModalTitle: String,
        deleteModalContent: String,
        tabindex: {
            type: Number,
            default: 0,
        },
    },
};
</script>
